export default "__VITE_ASSET__c6a50883__"